import {
  Text,
  Accordion,
  AccordionItem,
  Box,
  Stack,
  Heading,
} from 'braid-design-system';

export interface FAQ {
  question: string;
  answer: string;
}

interface FaqProp {
  faqs: FAQ[];
}

export const FaqAccordion = ({ faqs }: FaqProp) => (
  <Box data={{ testid: 'faq-accordion' }}>
    <Stack space="xlarge">
      <Stack space="medium">
        <Heading level="3" component="h2">
          Frequently asked selling questions
        </Heading>
        <Text tone="secondary">
          Find answers to common questions about selling your business privately
          on SEEK Business.
        </Text>
      </Stack>

      <Accordion space="medium">
        {faqs.map((faq, index) => (
          <AccordionItem label={faq.question} key={index} id={`faq-${index}`}>
            <Text>{faq.answer}</Text>
          </AccordionItem>
        ))}
      </Accordion>
    </Stack>
  </Box>
);
